import { UnidadeGestoraResumida } from "@/types/ug/unidade-gestora-resumida";

export class DateRange {
  startDate: Date;
  endDate: Date;
}
export class FiltrosDecisoes {
  numero: string;
  dataPublicacao: DateRange;
  ug?: UnidadeGestoraResumida;

  page = 1;
  pageSize = 10;

  constructor() {
    this.limpar();
  }

  limpar(): void {
    this.numero = "";
    this.dataPublicacao = new DateRange();
    this.ug = undefined;
  }

  toQueryString(): string {
    let retorno = `?page=${this.page}&pageSize=${this.pageSize}`;
    if (this.numero) retorno += "&protocolo=" + this.numero;
    if (this.dataPublicacao.startDate)
      retorno += "&dataInicial=" + this.dataPublicacao.startDate.toISOString();
    if (this.dataPublicacao.endDate)
      retorno += "&dataFinal=" + this.dataPublicacao.endDate.toISOString();
    if (this.ug?.Codigo) retorno += "&codUg=" + this.ug.Codigo;
    return retorno;
  }
}
